import { render, staticRenderFns } from "./ym-feed-feeding.vue?vue&type=template&id=145cfbdc&scoped=true&"
import script from "./ym-feed-feeding.vue?vue&type=script&lang=js&"
export * from "./ym-feed-feeding.vue?vue&type=script&lang=js&"
import style0 from "./ym-feed-feeding.vue?vue&type=style&index=0&id=145cfbdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145cfbdc",
  null
  
)

export default component.exports